/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Model_Standard_HintInputs */

const en_landing_studio_model_standard_hint = /** @type {(inputs: Landing_Studio_Model_Standard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanced speed and quality`)
};

const zh_landing_studio_model_standard_hint = /** @type {(inputs: Landing_Studio_Model_Standard_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度与质量均衡`)
};

/**
* | output |
* | --- |
* | "Balanced speed and quality" |
*
* @param {Landing_Studio_Model_Standard_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_model_standard_hint = /** @type {((inputs?: Landing_Studio_Model_Standard_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Model_Standard_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_model_standard_hint(inputs)
	return zh_landing_studio_model_standard_hint(inputs)
});
export { landing_studio_model_standard_hint as "landing.studio.model_standard_hint" }